import SummaryReportForm from "./SummaryReportForm";
import { TemplateWrapped } from "../../Layout";
import useSummaryReport from "./useSummaryReport";
import withSelectedPractices from "../../HOCS/withSelectedPractices/withSelectedPractices";
import React, { useContext } from "react";
import { AppContext } from "../../../App";
import { groupPractices } from "../Connections/connections.middleware";

const SummaryReport = () => {
  const { GetSummaryReport } = useSummaryReport();
  const appData = useContext(AppContext);
  const practices = appData.get("practices") || [];
  const clients = Object.values(groupPractices(practices)).map((client) => ({
    value: client.clientId,
    label: client.clientName,
  }));

  return (
    <>
      <TemplateWrapped showTitle={false}>
        <div
          className="panel"
          style={{
            backgroundColor: "transparent",
            boxShadow: "none",
            maxWidth: "80rem",
            width: "100%",
            margin: "0 auto",
          }}
        >
          <div className="panel-body">
            <main className="flex-1  pt-6 pb-8">
              {/* Page Header */}
              <div className="mb-8">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">
                  Summary Report
                </h1>
                <p className="text-gray-500"></p>
              </div>
              <div className="panel-body" style={{ backgroundColor: "white" }}>
                <SummaryReportForm
                  GetSummaryReport={GetSummaryReport}
                  clients={clients}
                  practices={practices}
                />
              </div>
            </main>
          </div>
        </div>
      </TemplateWrapped>
    </>
  );
};

export default withSelectedPractices(SummaryReport);
